import { create } from "zustand";

export const useNotesModalStore = create((set) => ({
  open: false,
  openModal: () => set({ open: true }),
  closeModal: () => set({ open: false }),
}));
